import getHourAndMinute from './getHourAndMinute';

const OneDayInMilliseconds = 1000 * 60 * 60 * 24;

/**
 * Turns a date string into a relative date string, i.e. "Today at 3:00pm",
 * "Yesterday at 3:00pm", or "January 1, 2020"
 */
export default function getRelativeDate(inputDate: string): string {
  const date = new Date(inputDate);
  const now = new Date();

  const startOfInputDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  const diffInTime = startOfToday.getTime() - startOfInputDate.getTime();
  const diffInDays = diffInTime / OneDayInMilliseconds;

  if (diffInDays === 0) {
    return `Today at ${getHourAndMinute(date)}`;
  } else if (diffInDays === 1) {
    return `Yesterday at ${getHourAndMinute(date)}`;
  } else {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }
}
